/**
 * Map Item Status Code To Text.
 * @param code - String mapping code.
 * @param resources - Object with translation keys.
 * @returns String value.
 */

export const mapItemStatusCodeToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalStatusItemUnknown;
        case '05':
            return resources.globalStatusItemQueued;
        case '10':
            return resources.globalStatusItemRequested;
        case '20':
            return resources.globalStatusItemItemCanceled;
        case '30':
            return resources.globalStatusItemConfirmed;
        case '40':
            return resources.globalStatusItemTransportPlanned;
        case '70':
            return resources.globalStatusItemGoodsDispatched;
        case '80':
            return resources.globalStatusItemGoodsReceived;
        default:
            return resources.globalStatusError;
    }
};

export const mapHeaderStatusCodeToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalStatusOrderUnknown;
        case '05':
            return resources.globalStatusOrderQueued;
        case '10':
            return resources.globalStatusOrderRequested;
        case '20':
            return resources.globalStatusOrderCanceled;
        case '30':
            return resources.globalStatusOrderConfirmed;
        case '50':
            return resources.globalStatusOrderPartiallyDispatched;
        case '70':
            return resources.globalStatusOrderGoodsDispatched;
        case '80':
            return resources.globalStatusOrderPartiallyReceived;
        case '90':
            return resources.globalStatusOrderCompleted;
        default:
            return resources.globalStatusError;
    }
};

export const mapItemInvoiceStatusCodeToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalInvoiceItemStatusUnknown;
        case '20':
            return resources.globalInvoiceItemStatusCanceled;
        case '30':
            return resources.globalInvoiceItemStatusPending;
        case '80':
            return resources.globalInvoiceItemStatusInvoiced;
        default:
            return resources.globalStatusError;
    }
};

export const mapHeaderInvoiceStatusCodeToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalInvoiceOrderStatusUnknown;
        case '20':
            return resources.globalInvoiceOrderStatusCanceled;
        case '30':
            return resources.globalInvoiceOrderStatusPending;
        case '60':
            return resources.globalInvoiceOrderStatusPartiallyInvoiced;
        case '80':
            return resources.globalInvoiceOrderStatusInvoiced;

        default:
            return resources.globalStatusError;
    }
};

export const mapItemStatusCodeDescriptionToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalStatusItemUnknownDescription;
        case '05':
            return resources.globalStatusItemQueuedDescription;
        case '10':
            return resources.globalStatusItemRequestedDescription;
        case '20':
            return resources.globalStatusItemItemCanceledDescription;
        case '30':
            return resources.globalStatusItemConfirmedDescription;
        case '40':
            return resources.globalStatusItemTransportPlannedDescription;
        case '70':
            return resources.globalStatusItemGoodsDispatchedDescription;
        case '80':
            return resources.globalStatusItemGoodsReceivedDescription;
        default:
            return resources.globalStatusErrorDescription;
    }
};

export const mapOrderStatusCodeDescriptionToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalStatusOrderUnknownDescription;
        case '05':
            return resources.globalStatusOrderQueuedDescription;
        case '10':
            return resources.globalStatusOrderRequestedDescription;
        case '20':
            return resources.globalStatusOrderCanceledDescription;
        case '30':
            return resources.globalStatusOrderConfirmedDescription;
        case '50':
            return resources.globalStatusOrderPartiallyDispatchedDescription;
        case '70':
            return resources.globalStatusOrderGoodsDispatchedDescription;
        case '80':
            return resources.globalStatusOrderPartiallyReceivedDescription;
        case '90':
            return resources.globalStatusOrderCompletedDescription;
        default:
            return resources.globalStatusErrorDescription;
    }
};

export const mapItemInvoiceStatusCodeDescriptionToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalInvoiceItemStatusUnknownDescription;
        case '20':
            return resources.globalInvoiceItemStatusCanceledDescription;
        case '30':
            return resources.globalInvoiceItemStatusPendingDescription;
        case '80':
            return resources.globalInvoiceItemStatusInvoicedDescription;
        default:
            return resources.globalStatusError;
    }
};

export const mapOrderInvoiceStatusCodeDescriptionToText = (code: string, resources: any): string => {
    switch (code) {
        case '00':
            return resources.globalInvoiceOrderStatusUnknownDescription;
        case '20':
            return resources.globalInvoiceOrderStatusCanceledDescription;
        case '30':
            return resources.globalInvoiceOrderStatusPendingDescription;
        case '60':
            return resources.globalInvoiceOrderStatusPartiallyInvoicedDescription;
        case '80':
            return resources.globalInvoiceOrderStatusInvoicedDescription;
        default:
            return resources.globalStatusError;
    }
};
